.list {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-2);
	inline-size: 100%;
	padding-block: var(--spacing-4);
}

/* A grouped-backlog lane's drop zone (TAS-60): the same stacked rows, but with a min-height
   so an empty lane still offers a hoverable target for a cross-lane drop. */
.laneStack {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-2);
	min-block-size: var(--control-height);
}

.laneEmpty {
	padding-block: var(--spacing-2);
	font-size: var(--font-size-sm);
	color: var(--colour-text-tertiary);
}

/* On mobile (the app's 640px breakpoint) the add field pins to the bottom of the
   viewport so it stays reachable while the list scrolls behind it; the list gets
   room at its end so the last rows are never hidden under the pinned bar. */
@media (width <= 640px) {
	.list {
		padding-block-end: calc(var(--control-height-sm) + var(--spacing-8));
	}

	.quickAddSlot {
		position: fixed;
		inset-block-end: 0;
		inset-inline: 0;
		z-index: 5;
		padding: var(--spacing-2) var(--spacing-4) max(var(--spacing-2), env(safe-area-inset-bottom));
		background: var(--colour-background-page);
		border-block-start: 1px solid var(--colour-border-subtle);

		/* The lift above the keyboard is a JS-set transform (see task-list.component);
		   slide to it, since iOS reports the viewport change once the keyboard settles. */
		transition: transform 0.2s ease;
	}

	@media (prefers-reduced-motion: reduce) {
		.quickAddSlot {
			transition: none;
		}
	}

	/* The field already carries its own bottom gap; drop it inside the pinned bar. */
	.quickAddSlot form {
		padding-block-end: 0;
	}
}
